export function registerSidebar() {
    Alpine.data('sidebarUnread', () => ({
        total: 0,
        _timer: null,
        init() {
            this._poll();
            this._timer = setInterval(() => this._poll(), 30000);
        },
        async _poll() {
            try {
                const r = await fetch('/api/chat/unread-count');
                if (r.ok) {
                    const d = await r.json();
                    this.total = d.total || 0;
                }
            } catch (e) {}
        }
    }));

    Alpine.data('mobileSidebar', () => ({
        open: false,
        toggle() { this.open = !this.open; },
        close() { this.open = false; },
    }));
}
